import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { PageService } from 'app/service/page/page.service';
import * as Swiper from "swiper";
import { PagePlan } from 'app/service/page/page';

@Component({
  selector: 'app-plan',
  templateUrl: 'plan.component.html',
  styleUrls: ['plan.component.scss'],
  providers: [PageService]
})

export class PlanComponent{
  isLoad: boolean = false;
  isMobile: boolean = false;
  location: string;
  locationTxt: string;
  store: PagePlan;

  swiper = null;
  config = {
    scrollbar: null,
    direction: 'horizontal',
    slidesPerView: 1,
    scrollbarHide: false,
    keyboardControl: false,
    mousewheelControl: false,
    scrollbarDraggable: true,
    scrollbarSnapOnRelease: true,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    autoplayStopOnLast: false,
    autoplayDisableOnInteraction: false,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    autoplay: 300000,
    loop: true,
    pagination: '.swiper-pagination',
    paginationType: 'bullets',
    paginationClickable: true,
  };

  @HostListener('window:resize', ['$event']) onResize(event) {
    let isMobile = (event.target.innerWidth < 768);
    if (this.isMobile != isMobile) {
      this.isMobile = isMobile;
    }
  }

  constructor(private pageService: PageService, private router: Router) {
    this.isMobile = (window.innerWidth < 768);
    this.location = router.url.split('/')[1]
    this.locationTxt = this.location === 'seongsu' ? '성수 시작점' : '서울숲점'
    this.store = new PagePlan()

    this.pageService.getPlan(this.location).subscribe(params => {
      this.store = params
      this.isLoad = true;
    });
  }

  ngAfterViewChecked() {
    if(this.isLoad && this.swiper === null) this.swiper = new Swiper('.swiper-container-plan-item', this.config);
  }
}



// WEBPACK FOOTER //
// ./src/app/space/plan/plan.component.ts